export default __webpack_public_path__ + "static/media/cg4.d6a20ca7.webp";